import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Users, PawPrint } from "lucide-react";
import { SITE, TEAM } from "@/data/site";

export default function Team() {
  return (
    <div data-testid="team-page">
      <section className="border-b border-white/10 bg-[#111] relative grain">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <p className="label-industrial text-ember mb-4">The Team</p>
          <h1 className="font-display text-6xl lg:text-8xl tracking-wide text-white" data-testid="team-heading">
            THE CREW ON THE FLOOR
          </h1>
          <p className="mt-6 text-gray-400 max-w-xl">
            The hands behind every build, service and WOF at {SITE.name}. Real people who know their trade and stand behind their work.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10" data-testid="team-grid">
          {TEAM.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-[#111] p-8"
              data-testid={`team-member-${i}`}
            >
              <div className="w-20 h-20 flex items-center justify-center border-2 border-ember bg-ember/10 mb-6 overflow-hidden">
                {m.photo ? (
                  <img src={m.photo} alt={m.name} className="w-full h-full object-cover" />
                ) : m.paw ? (
                  <PawPrint className="w-9 h-9 text-ember" />
                ) : (
                  <span className="font-display text-3xl tracking-wide text-ember">{m.initials}</span>
                )}
              </div>
              <h3 className="font-display text-3xl tracking-wide text-white">{m.name}</h3>
              <p className="label-industrial text-ember mt-1 mb-4">{m.role}</p>
              <p className="text-gray-400 text-sm leading-relaxed">{m.bio}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="border border-white/10 bg-[#111] p-10 lg:p-16 flex flex-col lg:flex-row items-start lg:items-center gap-8" data-testid="team-cta-banner">
          <Users className="w-12 h-12 text-ember shrink-0" />
          <div className="flex-1">
            <h3 className="font-display text-4xl tracking-wide text-white">COME TALK TO THE TEAM</h3>
            <p className="text-gray-400 text-sm mt-3 max-w-xl">
              Pop into the workshop at {SITE.location}, or get in touch and we'll sort you out.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="team-contact-link"
            className="label-industrial bg-ember text-white px-8 py-4 hover:bg-ember-hover hover:-translate-y-1 transition-[background-color,transform] duration-150 flex items-center gap-2 shrink-0"
          >
            Book a Job <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
